import React from 'react';
import Appointments from 'pages/appointments/Appointments';
// import { AdditionalInformationForm } from 'pages/productManagement/form/Additional_Information';
import Additional from './Additional';

function AdditionalContainer(prevStep, nextStep, handleChange) {
    return (
        <div>
            <Additional  prevStep={prevStep} nextStep={nextStep}/>
        </div>
    );
}

export default AdditionalContainer;